import url from './urls'

const state = {
  isLoading: false,
  menuGalleries: null,
  yearGalleries: null,
  listGallery: null,
  listRequestId: 0,
  menuRequestId: 0,
  error: false
}

const mutations = {
  START_MENUS (state) {
    state.menuRequestId += 1
    state.listRequestId += 1
    state.isLoading = true
    state.listGallery = []
    state.error = false
  },
  SET_MENUS (state, data) {
    state.menuGalleries = data
  },
  SET_YEARS (state, data) {
    state.yearGalleries = data
  },
  START_LIST (state) {
    state.listRequestId += 1
    state.isLoading = true
    state.listGallery = []
    state.error = false
  },
  SET_LIST (state, data) {
    state.listGallery = data
    state.isLoading = false
  },
  SET_ERROR (state, error) {
    state.error = error
  }
}

async function fetchGallery (endpoint) {
  const response = await fetch(endpoint)
  if (!response.ok) throw new Error('Unable to load gallery')
  const data = await response.json()
  if (!Array.isArray(data)) throw new Error('Invalid gallery response')
  return data
}

const actions = {
  async getMenus ({ state, commit }, year) {
    commit('START_MENUS')
    const requestId = state.menuRequestId
    try {
      const data = await fetchGallery(url.gallery.list + '?year=' + encodeURIComponent(year))
      if (requestId === state.menuRequestId) {
        commit('SET_MENUS', data)
        commit('SET_LIST', [])
      }
    } catch (err) {
      if (requestId === state.menuRequestId) {
        commit('SET_MENUS', [])
        commit('SET_LIST', [])
        commit('SET_ERROR', true)
      }
      console.error(err)
    }
  },

  async getYear ({ commit }, id) {
    commit('SET_ERROR', false)
    commit('SET_LIST', [])
    try {
      commit('SET_YEARS', await fetchGallery(url.gallery.year + id))
    } catch (err) {
      commit('SET_YEARS', [])
      commit('SET_ERROR', true)
      console.error(err)
    }
  },

  async getList ({ state, commit }, params) {
    commit('START_LIST')
    const requestId = state.listRequestId
    try {
      const data = await fetchGallery(url.gallery.detail + params.id + '/' + params.year)
      if (requestId === state.listRequestId) commit('SET_LIST', data)
    } catch (err) {
      if (requestId === state.listRequestId) {
        commit('SET_LIST', [])
        commit('SET_ERROR', true)
      }
      console.error(err)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
